import { PUBLIC_GTM_CONTAINER_ID } from 'astro:env/client';
import { ObservabilityStrategy } from '@/observability/observability';
import { init } from './tag-manager.sdk.client';

function bootstrap(): void {
	if (PUBLIC_GTM_CONTAINER_ID) {
		init(PUBLIC_GTM_CONTAINER_ID);

		return;
	}

	ObservabilityStrategy.recordError(
		new Error("Missing 'PUBLIC_GTM_CONTAINER_ID'"),
	);
}

bootstrap();
